import { ReactNode } from "react";

import { Columns, Gap } from "apps/website/maps/Grid.map";

import { IconSvg } from "../../base/Icon/Icon.map";
import { IllustrationSvg } from "../../base/Illustration/illustration.map";

export interface IRadioGroupProps<T extends IBaseRadioOption> {
  name: string;
  selectedValue?: string;
  options: T[];
  legend?: string;
  srOnlyLegend?: boolean;
  onChange: (value: string) => void;
  styleOptions?: {
    columns?: Columns;
    gap?: Gap;
    gapX?: Gap;
    gapY?: Gap;
  };
}

// Base radio option type
export interface IBaseRadioOption {
  label: string;
  value: string;
  component: string;
  disabled?: boolean;
  children?: ReactNode;
  childrenWrapperClassName?: string;
  selected?: boolean;
  // styleOptions?: {...}
}

// Default option types
export interface IDefaultOption extends IBaseRadioOption {
  component: "default";
}

export function isRadioDefaultOption(option: IBaseRadioOption): option is IDefaultOption {
  return option.component === "default";
}

export function isRadioDefaultOptions(options: IBaseRadioOption[]): options is IDefaultOption[] {
  return options.every((option) => option.component === "default");
}

// Card option types
export interface ICardOption extends IBaseRadioOption {
  component: "card";
  icon: IconSvg;
  selectedIcon?: IconSvg;
  description?: string;
}

export function isRadioCardOption(option: IBaseRadioOption): option is ICardOption {
  return option.component === "card";
}

export function isRadioCardOptions(options: IBaseRadioOption[]): options is ICardOption[] {
  return options.every((option) => option.component === "card");
}

// List option types
export interface IListOption extends IBaseRadioOption {
  component: "list";
  icon?: IconSvg;
  selectedIcon?: IconSvg;
  description?: string;
}

export function isRadioListOption(option: IBaseRadioOption): option is IListOption {
  return option.component === "list";
}

export function isRadioListOptions(options: IBaseRadioOption[]): options is IListOption[] {
  return options.every((option) => option.component === "list");
}

// Spotlight option types
export interface ISpotlightOption extends IBaseRadioOption {
  component: "spotlight";
  illustration: IllustrationSvg;
}

export function isRadioSpotlightOption(option: IBaseRadioOption): option is ISpotlightOption {
  return option.component === "spotlight";
}

export function isRadioSpotlightOptions(options: IBaseRadioOption[]): options is ISpotlightOption[] {
  return options.every((option) => option.component === "spotlight");
}
